
import { Component, ElementRef, ViewChild } from '@angular/core';
import {
  FormGroup,
  FormBuilder,
  Validators,
  ValidatorFn,
  AbstractControl,
  FormArray,
} from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { ToasterMessages } from 'src/app/shared/constants/constants';
import { getSegmentOptions } from 'src/app/shared/helpers/Drop-down-options';
import { PortRequestFormServiceService } from 'src/app/shared/service/port-request-FormService/port-request-form.service.service';
import { RequestFormService } from 'src/app/shared/service/requestForm/request-form.service';

import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { PortsPopupComponent } from '../../request-form/pages/ports-popup/ports-popup.component';
import { ReportVerifyPopupComponent } from 'src/app/shared/components/report-verify-popup/report-verify-popup.component';
import { ClientPopupComponent } from '../../onboarding-form/client-popup/client-popup.component';
import { RetriveReportsFetchComponent } from 'src/app/shared/components/retrive-reports-fetch/retrive-reports-fetch.component';
import { UploadfileValidationComponent } from 'src/app/shared/components/uploadfile-validation/uploadfile-validation.component';

import { CheckcospSubmitformComponent } from '../checkcosp-submitform/checkcosp-submitform.component';
import { OptimizationPopupComponent } from '../port-request-form/pages/optimization-popup/optimization-popup.component';
import { SisterShipPopupComponent } from '../port-request-form/pages/sister-ship-popup/sister-ship-popup.component';

@Component({
  selector: 'app-dataqueality-checkform',
  templateUrl: './dataqueality-checkform.component.html',
  styleUrls: ['./dataqueality-checkform.component.scss']
})
export class DataquealityCheckformComponent {
  requestForm!: FormGroup;
  formSubmitted: boolean = false;
  clientOptions: any;

  anyotherOperations = ['Heating', 'Inerting', 'Tank Cleaning'];
  typeofOperations = ['Loading', 'Discharging'];
  statusOptions = ['Maneuvering', 'Idle'];
  dischargingSystem = ['Framo', 'Cop', 'MARFLEX'];
  portNameSuggestions: any[] = [];
  filteredPortNames: any[] = [];
  shipyardOptions = ['TBD'];
  typeofshipOptions = [
    'Bulk Carrier',
    'Chem Tanker',
    'Container',
    'General CArgo',
    'Oil Tanker',
    'Tanker',
  ];
  merakiPicOptions = [
    { label: 'ALS - Alexroger', value: 'ALS' },
    { label: 'HAJ - Hancy', value: 'HAJ' },
    { label: 'HAS - Harshi', value: 'HAS' },
    { label: 'KER - Keerthana', value: 'KER' },
    { label: 'INV - Indhirani', value: 'INV' },
    { label: 'MAL - Malini', value: 'MAL' },
    { label: 'PHJ - Philomina', value: 'PHJ' },
    { label: 'PRA - Priya', value: 'PRA' },
    { label: 'RAS - Rajeswari', value: 'RAS' },
    { label: 'SAG - Santhosh', value: 'SAG' },
    { label: 'SOS - Souta Samanta ', value: 'SOS' },
    { label: 'BHY - Bhargavi', value: 'BHY' },
    { label: 'NAB - Nancy', value: 'NAB' },
    { label: 'DEKA - Deepika', value: 'DEKA' },
    { label: 'ARYA - Arbaaz', value: 'ARYA' },
    { label: 'HRIT - Hritik', value: 'HRIT' },
    { label: 'NIMA- Niharika Mahajan', value: 'NIMA' },
    { label: 'TST - Test', value: 'TST' },
    { label: 'ANKU ', value: 'ANKU ' },
    { label: 'SUTH', value: 'SUTH' },
    { label: 'Sowmya', value: 'SOKU' },
    { label: 'Manisha', value: 'MAGA' },
    { label: 'Jeevan', value: 'Jeev' },
  ];
  weatherSourceOptions = [
    { label: 'DTN', value: 'DTN' },
    { label: 'Storm Glass', value: 'stormglass' },
  ];
  eigerPicOptions = [
    { label: 'SAKA - Satish', value: 'SAKA' },
    { label: 'SABA - Sandokan', value: 'SABA' },
    { label: 'ROAK - Roman', value: 'ROAK' },
    { label: 'AAHA - Ahmet', value: 'AAHA' },
    { label: 'NIAL - Nikita', value: 'NIAL' },
    // { label: 'JESH - Jeet', value: 'JESH' },
    { label: 'RAPA - Rahul', value: 'RAPA' },
    { label: 'AHKM - Abhishek', value: 'AHKM' },
    { label: 'SAMH - Sadique Muhammad', value: 'SAMH' },
    { label: 'ALYI - Alex', value: 'ALYI' },
  ];
  segmentOptions: any = [
    { label: 'Coaster', value: 'Coaster' },
    { label: 'Handysize', value: 'Handysize' },
    { label: 'Handymax', value: 'Handymax' },
    { label: 'Supramax', value: 'Supramax' },
    { label: 'Ultramax', value: 'Ultramax' },
    { label: 'Panamax', value: 'Panamax' },
    { label: 'Kamsarmax', value: 'Kamsarmax' },
    { label: 'Ultra Panamax', value: 'Ultrapanamax' },
    { label: 'Capesize', value: 'Capesize' },
    { label: 'Very Large Ore Carrier', value: 'VLOC' },
    { label: 'Chinamax', value: 'Chinamax' },
    { label: 'Coastal', value: 'Coastal' },
    { label: 'Intermediate', value: 'Intermediate' },
    { label: 'Handytankers', value: 'Handytankers' },
    { label: 'MR', value: 'MR' },
    { label: 'LR1 / Panamax', value: 'LR1/Panamax' },
    { label: 'LR2 / Aframax', value: 'LR2/Aframax' },
    { label: 'LR3 / Suezmax', value: 'LR3/Suezmax' },
    { label: 'VLCC', value: 'VLCC' },
    { label: 'Coasters', value: 'Coasters' },
    { label: 'MGC', value: 'MGC' },
    { label: 'LGC', value: 'LGC' },
    { label: 'VLGC', value: 'VLGC' },
    { label: 'VLEC', value: 'VLEC' },
  ];
  typeOfSpeedOptions = [
    { label: 'Constant Speed', value: 'CP Speed' },
    {
      label: 'Optimal Speed(Reefer container)',
      value: 'Optimal Speed(Reefer container)',
    },
    { label: 'Optimal Speed', value: 'Optimal Speed' },
  ];
  voyageTypeOptions = [
    { label: 'Laden', value: 'Laden' },
    { label: 'Ballast', value: 'Ballast' },
  ];
  reportTypeOptions = [
    { label: 'Transit', value: 'Transit' },
    { label: 'Berth', value: 'Port' },
  ];
  yesNo = [
    { label: 'Yes', value: 'YES' },
    { label: 'No', value: 'NO' },
  ];
  weatherfactorOptions = [
    { label: 'Yes', value: 'YES' },
    { label: 'No', value: 'NO' },
  ];
  yesNoDayPositive = [
    { label: 'Yes', value: 'all_day_positive' },
    { label: 'No', value: 'no' },
  ];
  duelFuelOptions = [
    { label: 'Yes', value: 'excluded' },
    { label: 'No', value: 'included' },
  ];
  adverseCurrentValue = [
    { label: 'Yes', value: 'x' },
    { label: 'No', value: 'inc' },
  ];
  yesNo3 = [
    { label: 'Yes', value: 'YES' },
    { label: 'No', value: 'NO' },
    { label: 'N/A', value: 'Not Applicable' },
  ];
  wetherCalculationOptions = [
    { label: 'BF Only', value: 'BF' },
    { label: 'DSS', value: 'DSS' },
    { label: 'SWH', value: 'SWH' },
    { label: 'SWH&DSS', value: 'SWH+DSS' },
    { label: 'Wind Wave & Swell Height', value: 'Wind Wave & Swell Height' },
  ];

  performanceCalOptions = [
    { label: 'Voyage', value: 'Voyage' },
    { label: 'Daily', value: 'Daily' },
  ];
  templetOptions = [
    { label: 'Weather Report', value: 'weather_report' },
    // { label: 'Ballast', value: 'Ballast' },
  ];
  goodWeatherPeriod = [12, 15, 18, 24];
  windBeaufort = [2, 3, 4, 5, 6];
  fuelType = ['ULSFO', 'VLSFO', 'HSFO', 'MDO', 'LNG', 'OTHERS', 'NA'];
  bunkerGradeOptions1: string[] = ['HSFO', 'VLSFO', 'MGO', 'LNG', 'ULSFO']; // example grades
  bunkerGradeOptions2: string[] = ['HSFO', 'VLSFO', 'MGO', 'LNG', 'ULSFO'];
  bunkerGradeOptions3: string[] = ['HSFO', 'VLSFO', 'MGO', 'LNG', 'ULSFO'];
  fromOptions: string[] = [
    'Singapore Transit',
    'Dardanelles',
    'Bosporus',
    'Turkish Strait',
    'Suez Canal',
    'Panama Canal',
    'Danish Strait',
  ];
  selectedFile!: File;
  selectedMainCPFile!: File;
  @ViewChild('fileInput') fileInput: ElementRef | undefined;
  @ViewChild('fileUpload') fileUpload: ElementRef | undefined;
  datesValidator: boolean = false;
  latDir = ['N', 'S'];
  longDir = ['E', 'W'];
  id: any;
  reportGenerate: boolean = false;
  mainCpFile: boolean = false;
  dataToPass: any;
  selectedRequestformFile: any;
  previousValue: any;
  weatherFactor: boolean = false;
  bunkerOperationIsYes: boolean = true;
  fileId: any;

  isUpload: boolean = false;
  @ViewChild('requestformFileInput')
  requestformFileInput!: ElementRef<HTMLInputElement>;
  PortRequestFormServiceService: any;
  portDetails: any;

  constructor(
    private fb: FormBuilder,
    private toastr: ToastrService,
    private requestFormService: RequestFormService,
    private pRequestFormService: PortRequestFormServiceService,
    private dialog: MatDialog,
    private router: Router,
  ) {
    this.requestForm = this.fb.group({
      merakiPic: ['', Validators.required],
      clientPic: [''],
      vesselName: ['', Validators.required],
      imoNumber: ['', Validators.required],
      voyNumber: [''],
      segment: [''],
      shipYard: [''],
      Yearbuilt: [''],
      typeOfShip: [''],
      portName: ['', Validators.required],
      pfrom: [{ value: '', disabled: true }, Validators.required],
      pto: [''],
      reportType: ['', Validators.required],
      // eca: [''],
      fuelType: ['', Validators.required],
      fuelTypeOne: ['', Validators.required],
      fuelTypeTwo: ['', Validators.required],
      vesselFitted: [''],
      bunkerOperataion: [''],
      quaBunkerGradeOne: [''],
      quantityOne: [''],
      quaBunkerGradeTwo: [''],
      quantityTwo: [''],
      quaBunkerGradeThree: [''],
      quantityThree: [''],
      disBunkerGradeOne: [''],
      disNumericValueOne: [''],
      disBunkerGradeTwo: [''],
      disNumericValueTwo: [''],
      disBunkerGradeThree: [''],
      disNumericValueThree: [''],
      otherOperations: this.fb.array([this.createOperationGroup()]),
      ecaRegion: [''],
      cosp: [''],
      cospHours: [''],
      cospMinutes: [''],
      eosp: [''],
      eospHours: [''],
      eospMinutes: [''],
      client: ['', Validators.required],
      typeOfOperations: ['', Validators.required],
      cargoQuantity: [''],
      pumpRPM: ['', Validators.required],
      no_of_pump: [''],
      ae_tcp: [''],
      fuelMinTol: ['', Validators.required],
      reportedDate: ['', Validators.required],
      reportedHours: [''],
      reportedMinutes: [''],
      additionalComments: [''],
      file_id: [''],
    });

  }

  ngOnInit(): void {
    this.loadClientOptions();
    this.requestForm.get('reportType')?.valueChanges.subscribe((val) => {
      if (val === 'Transit') {
        this.requestForm.get('pfrom')?.enable();
      } else {
        this.requestForm.get('pfrom')?.disable();
        this.requestForm.get('pfrom')?.setValue('');
      }
    });
    this.pRequestFormService.getPortDetails().subscribe({
      next: (response: any) => {
        // Use 'ports' array from API response
        this.filteredPortNames = response?.ports ?? [];
        console.log('Filtered Port Names:', this.filteredPortNames);
      },
      error: (err: any) => {
        console.error('Error fetching port list:', err);
      },
    });
    this.requestForm
      .get('bunkerOperataion')
      ?.valueChanges.subscribe((value: string) => {
        this.bunkerOperationIsYes = value === 'Yes';
      });
  }
  openUploadPopup() {
    const dialogRef = this.dialog.open(UploadfileValidationComponent, {
      width: '900px',
      maxWidth: '100vw',
      disableClose: true,
      panelClass: 'upload-dialog-container',
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        console.log('Upload completed');
      }
    });
  }
  openRetrievePopup(): void {
    const dialogRef = this.dialog.open(RetriveReportsFetchComponent, {
      width: '900px',
      maxWidth: '95vw',
      maxHeight: '90vh',
      disableClose: true,
    });

    dialogRef.afterClosed().subscribe((result: any) => {
      if (result) {
        console.log('Retrieve popup result:', result);
      }
    });
  }
  loadClientOptions() {
    this.requestFormService.getClientList().subscribe({
      next: (res: any[]) => {
        this.clientOptions = res.map((client) => client.client_name);
      },
      error: (err) => console.error('Client API error', err),
    });
  }
  filterPortNames(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value.toLowerCase();

    if (this.filteredPortNames && event) {
      this.portNameSuggestions = this.filteredPortNames
        .map((p) => (Array.isArray(p.port_name) ? p.port_name[0] : ''))
        .filter((name) => name.toLowerCase().startsWith(filterValue));
    } else {
      this.portNameSuggestions = [];
    }

    console.log('Suggestions:', this.portNameSuggestions);
  }

  onPortSelected(selectedPortName: string) {
    this.requestForm.get('pfrom')?.setValue(selectedPortName);

    const selected = this.filteredPortNames.find(
      (p) => Array.isArray(p.port_name) && p.port_name[0] === selectedPortName,
    );

    if (selected) {
      this.requestForm.get('pto')?.setValue(selected.region || '');
      this.requestForm.get('pfrom')?.setValue(selected.code || '');
    }

    this.portNameSuggestions = [];
  }

  get otherOperations(): FormArray {
    return this.requestForm.get('otherOperations') as FormArray;
  }
  createOperationGroup(): FormGroup {
    return this.fb.group({
      anyOtherOperations: [''],
      operationHours: [0],
      status: [''],
    });
  }

  addRow() {
    if (this.otherOperations.length < 3) {
      this.otherOperations.push(this.createOperationGroup());
    }
  }

  removeRow(index: number) {
    this.otherOperations.removeAt(index);
  }
  isDarkMode() {
    return this.requestFormService.isDarkMode();
  }
  onInputChange(event: Event, controlName: string) {
    const inputElement = event.target as HTMLInputElement;
    const currentValue = inputElement.value;
    if (currentValue.length > 30) {
      inputElement.value = currentValue.slice(0, 30);
    }
    this.requestForm.get(controlName)?.setValue(inputElement.value);
  }
  onVoyageChange(event: Event, controlName: string) {
    const inputElement = event.target as HTMLInputElement;
    const currentValue = inputElement.value;
    if (currentValue.length > 10) {
      inputElement.value = currentValue.slice(0, 10);
    }
    this.requestForm.get(controlName)?.setValue(inputElement.value);
  }
  onInput(event: Event, controlName: string) {
    const inputElement = event.target as HTMLInputElement;
    let currentValue = inputElement.value;
    const numericValue = currentValue.replace(/[^0-9.]/g, '');
    const maxLength = 4;
    if (numericValue.length > maxLength) {
      inputElement.value = numericValue.slice(0, maxLength);
    } else {
      inputElement.value = numericValue;
    }
    this.requestForm.get(controlName)?.setValue(inputElement.value);
  }
  numberInput(event: Event, controlName: string) {
    const inputElement = event.target as HTMLInputElement;
    let currentValue = inputElement.value;
    const numericValue = currentValue.replace(/[^0-9.]/g, '');
    inputElement.value = numericValue;
    this.requestForm.get(controlName)?.setValue(inputElement.value);
  }
  defaultFormValues = {
    merakiPic: '',
    clientPic: '',
    vesselName: '',
    imoNumber: '',
    voyNumber: '',
    segment: '',
    shipYard: '',
    Yearbuilt: '',
    typeOfShip: '',
    portName: '',
    pfrom: '',
    pto: '',
    reportType: '',
    fuelType: '',
    fuelTypeOne: '',
    fuelTypeTwo: '',
    vesselFitted: '',
    bunkerOperataion: '',
    quaBunkerGradeOne: '',
    quantityOne: '',
    quaBunkerGradeTwo: '',
    quantityTwo: '',
    quaBunkerGradeThree: '',
    quantityThree: '',
    disBunkerGradeOne: '',
    disNumericValueOne: '',
    disBunkerGradeTwo: '',
    disNumericValueTwo: '',
    disBunkerGradeThree: '',
    disNumericValueThree: '',
    otherOperations: [this.createOperationGroup()],
    // cosp: '',
    // cospHours: '',
    // cospMinutes: '',
    // eosp: '',
    // eospHours: '',
    // eospMinutes: '',
    client: '',
    typeOfOperations: '',
    cargoQuantity: '',
    pumpRPM: '',
    fuelMinTol: '',
    reportedDate: '',
    reportedHours: '',
    reportedMinutes: '',
    additionalComments: '',
    file_id: '',
  };
  clearClick() {
    this.requestForm.get('cosp')?.clearValidators();
    this.requestForm.get('cospHours')?.clearValidators();
    this.requestForm.get('cospMinutes')?.clearValidators();
    this.requestForm.get('eosp')?.clearValidators();
    this.requestForm.get('eospHours')?.clearValidators();
    this.requestForm.get('eospMinutes')?.clearValidators();
    this.requestForm.reset(this.defaultFormValues);
    this.requestForm.setControl(
      'otherOperations',
      this.fb.array([this.createOperationGroup()]),
    );
    this.formSubmitted = false;
    this.isUpload = false;
    this.selectedRequestformFile = null;
    if (this.requestformFileInput) {
      this.requestformFileInput.nativeElement.value = '';
    }
  }
  submitClick() {

    const dialogRef = this.dialog.open(CheckcospSubmitformComponent, {
      width: '420px'
    });

    dialogRef.afterClosed().subscribe((selectedVersion) => {
      if (selectedVersion) {
        this.finalSubmit(selectedVersion);
      }
    });

  }
  finalSubmit(version: string) {

    const numericFields = [
      'cargoQuantity',
      'quantityOne',
      'quantityTwo',
      'quantityThree',
      'disNumericValueOne',
      'disNumericValueTwo',
      'disNumericValueThree',
      'pumpRPM',
      'fuelMinTol',
      'operationHours',
    ];

    this.normalizeNumberFields(numericFields);

    if (this.requestForm.get('reportType')?.value === 'Transit') {
      this.requestForm.get('pfrom')?.setValue(this.requestForm.get('portName')?.value);
      this.requestForm.get('portName')?.setValue('');
    }

    const json = {
      ...this.requestForm.value,
      version: version   // 👈 important (popup se aaya)
    };

    this.pRequestFormService.PostRequestForm(json).subscribe(
      (data) => {
        this.toastr.success(ToasterMessages.SubmitForm);
        this.clearClick();
      },
      (error) => {
        this.toastr.error(ToasterMessages.Error);
      }
    );

  }
  normalizeNumberFields(fields: string[]) {
    fields.forEach((field) => {
      const control = this.requestForm.get(field);
      if (control && (control.value === null || control.value === '')) {
        control.setValue(0);
      }
    });
  }

  topClick() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  restrictInput(inputField: any, maxAllowed: any) {
    inputField.value = inputField.value.replace(/^0+/, '');
    if (parseInt(inputField.value) > maxAllowed) {
      inputField.value = maxAllowed;
    }
    if (inputField.value === '0' || inputField.value === '') {
      inputField.value = '00';
    }
    if (inputField.value.length === 1) {
      inputField.value = '0' + inputField.value;
    }
  }

  validateHours(event: Event) {
    const input = event.target as HTMLInputElement;
    let value = parseFloat(input.value);

    if (isNaN(value)) return;

    if (value < 0) {
      input.value = '0';
    }
  }

  maxWordsValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      const value: string = control.value || '';
      const words: string[] = value.trim().split(/\s+/);
      if (words.length > 1500) {
        return { maxWordsExceeded: true };
      }
      return null;
    };
  }

  onRequestformFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input?.files?.length) {
      this.selectedRequestformFile = input.files[0];
      console.log('Uploaded File Name:');
    }
    this.pRequestFormService.uploadFile(this.selectedRequestformFile).subscribe(
      (data) => {
        this.requestForm.patchValue(data);
        this.fileId = data.file_id;
        this.isUpload = true;
        if (data.segment) {
          const matchedSegment = this.segmentOptions.find(
            (option: any) =>
              option.toLowerCase() === data.segment.toLowerCase(),
          );

          data.segment = matchedSegment || null; // set properly formatted value
        }

      },
      (error) => {
        this.toastr.warning(ToasterMessages.fileFormat);
      },
    );
  }
  setETA(etaString: string) {
    if (!etaString) return;

    // Remove 'LT' and split date & time parts
    const [datePart, timePart] = etaString.replace(' LT', '').split(' ');

    // Month mapping
    const months: { [key: string]: string } = {
      JAN: '01',
      FEB: '02',
      MAR: '03',
      APR: '04',
      MAY: '05',
      JUN: '06',
      JUL: '07',
      AUG: '08',
      SEP: '09',
      OCT: '10',
      NOV: '11',
      DEC: '12',
    };

    // Convert date format from "DD-MMM-YY" to "YYYY-MM-DD"
    const [day, monthAbbr, year] = datePart.split('-');
    const formattedDate = `20${year}-${months[monthAbbr]}-${day}`;

    // Extract hours and minutes
    const [hours, minutes] = timePart.split(':');

    // Set values to form fields
    this.requestForm.get('etaDate')?.setValue(formattedDate);
    this.requestForm.get('etaHours')?.setValue(hours);
    this.requestForm.get('etaMinutes')?.setValue(minutes);
  }
  convertLatLong(latStr: string, longStr: string) {
    let lat, latDir, long, longDir;

    // Ensure latStr and longStr are treated as strings
    const latString = latStr.toString();
    const longString = longStr.toString();

    // Convert Latitude
    if (latString.includes('N') || latString.includes('S')) {
      latDir = latString.includes('N') ? 'N' : 'S';
      lat = parseFloat(latString.replace(/[^\d.-]/g, '')); // Remove non-numeric characters and convert to float
      if (latDir === 'S') lat = -lat; // Convert to negative if South
    } else {
      lat = parseFloat(latString);
      latDir = lat >= 0 ? 'N' : 'S'; // Determine direction based on sign
      lat = Math.abs(lat); // Store absolute value in form
    }

    // Convert Longitude
    if (longString.includes('E') || longString.includes('W')) {
      longDir = longString.includes('E') ? 'E' : 'W';
      long = parseFloat(longString.replace(/[^\d.-]/g, '')); // Remove non-numeric characters and convert to float
      if (longDir === 'W') long = -long; // Convert to negative if West
    } else {
      long = parseFloat(longString);
      longDir = long >= 0 ? 'E' : 'W'; // Determine direction based on sign
      long = Math.abs(long); // Store absolute value in form
    }

    // Populate form fields
    this.requestForm.get('currLat')?.setValue(lat);
    this.requestForm.get('latDir')?.setValue(latDir);
    this.requestForm.get('currLng')?.setValue(long);
    this.requestForm.get('longDir')?.setValue(longDir);
  }
  addClick() {
    const dialog = this.dialog.open(PortsPopupComponent, {
      width: '600px',
      height: '400px',
      disableClose: true,
    });
    dialog.afterClosed().subscribe((result) => {
      this.portDetails.getPortDetails().subscribe((response: any) => {
        this.filteredPortNames = response?.data ?? [];
      });
    });
  }
  viewReport(): void {
    const dialogRef = this.dialog.open(ReportVerifyPopupComponent, {
      width: '900px',
      maxWidth: '95vw',
      maxHeight: '90vh',
      disableClose: true,
    });

    dialogRef.afterClosed().subscribe((result) => {
      console.log('Popup closed. Result:', result);
      // Optional: refresh or take action based on popup result
    });
  }
  sisterShipClick() {
    const dialogRef = this.dialog.open(SisterShipPopupComponent, {
      width: '500px',
      height: '300px',
      disableClose: true,
    });

    dialogRef
      .afterClosed()
      .subscribe((result: { vesselName: any; vesselIMO: any }) => {
        if (result) {
          console.log('Received Vessel Data:', result);
          // Use the data in this component as needed
        }
      });
  }

  addClientClick() {
    const dialog = this.dialog.open(ClientPopupComponent, {
      width: '600px',
      height: '400px',
      disableClose: true,
    });
    dialog.afterClosed().subscribe((result) => {
      // call API to get Client names
    });
  }
  optimizationClick() {
    const dialog = this.dialog.open(OptimizationPopupComponent, {
      width: '670px',
      height: '470px',
      disableClose: true,
      autoFocus: false,
    });
  }

  isAdmin(): boolean {
    const username = localStorage.getItem('username') ?? '';
    if (username !== 'Meraki - Operations') return false;

    const loginPic = localStorage.getItem('loginPic') ?? '';
    const subUsername = localStorage.getItem('subUsername') ?? '';
    const storedBunge = localStorage.getItem('bungeUsername') ?? '';

    const bungeUsername =
      loginPic && loginPic !== 'null'
        ? `${subUsername}_${loginPic}`
        : storedBunge || username;

    const bungeKey = String(bungeUsername).toLowerCase();
    const picKey = String(loginPic).toLowerCase();
    const subKey = String(subUsername).toLowerCase();

    return (
      bungeKey === 'meraki_superadmin' ||
      bungeKey === 'meraki_admin' ||
      bungeKey === 'meraki_sosa' ||
      bungeKey === 'meraki_gusi' ||
      bungeKey.includes('admin') ||
      picKey.includes('admin') ||
      picKey === 'sosa' ||
      picKey === 'gusi' ||
      subKey.includes('admin') ||
      subKey === 'sosa' ||
      subKey === 'gusi'
    );
  }

  reportDeskClick(): void {
    this.router.navigate(['/admin/report-desk']);
  }
}
